export const USER_CONSTS = {
  moduleName: 'epb-user',

  getters: {
    user: 'user'
  },
  actions: {
    loadUser: 'loadUser',
    persistUser: 'persistUser',
    clearModule: 'clearModule'
  },
  mutations: {
    setUser: 'setUser',
    clearModule: 'clearModule'
  }

};
